module.exports = __webpack_public_path__ + "img/certificate-picture.0cbada17.png";